"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1647],{

/***/ 11647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getTokenList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _uniswap_token_lists_src_tokenlist_schema_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40475);
/* harmony import */ var ajv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65096);
/* harmony import */ var ajv__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ajv__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pancakeswap_utils_uriToHttp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4278);
/* eslint-disable no-continue */ /* eslint-disable no-await-in-loop */ 




var tokenListValidator = new (ajv__WEBPACK_IMPORTED_MODULE_1___default())({
    allErrors: true
}).compile(_uniswap_token_lists_src_tokenlist_schema_json__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Contains the logic for resolving a list URL to a validated token list
 * @param listUrl list url
 */ function getTokenList(listUrl) {
    return _getTokenList.apply(this, arguments);
}
function _getTokenList() {
    _getTokenList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(listUrl) {
        var urls, i, url, isLast, response, error, json, ref, ref1, validationErrors;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    urls = (0,_pancakeswap_utils_uriToHttp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(listUrl);
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < urls.length)) return [
                        3,
                        8
                    ];
                    url = urls[i];
                    isLast = i === urls.length - 1;
                    response = void 0;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch list", listUrl, error);
                    if (isLast) throw new Error("Failed to download list ".concat(listUrl));
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!response.ok) {
                        if (isLast) throw new Error("Failed to download list ".concat(listUrl));
                        return [
                            3,
                            7
                        ];
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 6:
                    json = _state.sent();
                    if (!tokenListValidator(json)) {
                        ;
                        ;
                        validationErrors = (ref1 = (ref = tokenListValidator.errors) === null || ref === void 0 ? void 0 : ref.reduce(function(memo, error) {
                            var _message;
                            var add = "".concat(error.dataPath, " ").concat((_message = error.message) !== null && _message !== void 0 ? _message : "");
                            return memo.length > 0 ? "".concat(memo, "; ").concat(add) : "".concat(add);
                        }, "")) !== null && ref1 !== void 0 ? ref1 : "unknown error";
                        throw new Error("Token list failed validation: ".concat(validationErrors));
                    }
                    return [
                        2,
                        json
                    ];
                case 7:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 8:
                    throw new Error("Unrecognized list URL protocol.");
            }
        });
    });
    return _getTokenList.apply(this, arguments);
}


/***/ }),

/***/ 4278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
}


/***/ })

}]);